import React from 'react'
import { Text } from '@sketch/components'

interface NewFeatureHighlightPopoverBodyDefaultProps {
  titleText: string
  bodyText: string
}

const NewFeatureHighlightPopoverBodyDefault: React.FC<NewFeatureHighlightPopoverBodyDefaultProps> = ({
  titleText,
  bodyText,
}) => {
  return (
    <>
      <Text fontSize="E" fontWeight="medium">
        {titleText}
      </Text>
      <Text mt={2} textStyle="copy.tertiary.standard.C">
        {bodyText}
      </Text>
    </>
  )
}

export default NewFeatureHighlightPopoverBodyDefault
